import {Routes} from '@angular/router';
import {SubjectsRootComponent} from './subjects-root.component';
import {SubjectsNavigationComponent} from './subjects-navigation.component';
import {LabTestsGridComponent} from '../../subjects/lab-tests-grid.component';
import {LabTestsChartComponent} from '../../subjects/lab-tests-chart.component';
import {SubjectsListResolver} from './subjects-list-resolver';
import {SelectedSubjectResolver} from './selected-subject-resolver';
import { navigationActivity } from '../../activities/navigation-activity/navigation-activity-resolver';
import { PageTitle } from '../../core/page-title';
import { investigatorDefaultActivityHandler } from '../../activities/navigation-activity/handlers/investigator/investigator-default-activity-handler';

export const subjectsRoutes: Routes = [
    {
        path: 'subjects',
        data: { title: PageTitle.getInvestigatorTitle('Subjects') },
        resolve: {
            subjects: SubjectsListResolver
        },
        children: [
            {
                path: '',
                component: SubjectsRootComponent
            },
            {
                path: ':zcSubjectId',
                resolve: {
                    selectedSubject: SelectedSubjectResolver
                },
                component: SubjectsNavigationComponent,
                children: [
                    {
                        path: 'lab-tests-grid',
                        component: LabTestsGridComponent,
                        data: { ...investigatorDefaultActivityHandler('View Subjects - Table') },
                        resolve: { ...navigationActivity },
                    },
                    {
                        path: 'lab-tests-chart',
                        component: LabTestsChartComponent,
                        data: { ...investigatorDefaultActivityHandler('View Subjects - Chart') },
                        resolve: { ...navigationActivity },
                    },
                    { path: '**', redirectTo: 'lab-tests-grid', pathMatch: 'full' }
                ]
            }
        ]
    }
];